var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-footer",class:{'single': _vm.buttons.length === 1}},_vm._l((_vm.buttons),function(button){return _c('button',{staticClass:"button",class:button.class,attrs:{"disabled":button.disabled},on:{"click":function($event){$event.preventDefault();return _vm.emit(button.event)}}},[_vm._v(" "+_vm._s(button.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }